import { Pipe, PipeTransform } from '@angular/core';
import { DatesService } from '../../shared/services/dates.service';

@Pipe({
  name: 'dateFns',
  pure: true,
})
export class DatePipe implements PipeTransform {
  constructor(public datesService: DatesService) {}
  transform(value: any, dateFormat: string): string {
    if (value == null) {
      return;
    }
    return this.datesService.formatDate(value, dateFormat);
  }
}
